import ComposeViewState from '../store/schema/ComposeViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'removeInternetHeaders',
    (viewState: ComposeViewState, headerNames: string[]) => {
        headerNames.forEach(name => {
            if (viewState.internetHeaders.get(name)) {
                viewState.keysOfInternetHeadersToBeRemoved.push(name);
                viewState.internetHeaders.delete(name);
            }
        });
    }
);
